import React from "react";
import { Link } from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faInfo,
  faChartArea,
  faUser,
  faChartPie,
  faChartBar,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";

const CcpSchoolLinks = () => {
  const [openSettings, setOpenSettings] = React.useState(false);
  const theme = useTheme();

  const handleSettingsToggle = () => {
    setOpenSettings(!openSettings);
  };
  return (
    <>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpSchoolAccountProfile">
          <ListItemText
            primary="Account Profile"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpSchoolAppsAndTesting">
          <ListItemText
            primary="Apps & Testing"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpSchoolHelp">
          <ListItemText
            primary="Help & FAQ's"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpSchoolReports">
          <ListItemText
            primary="Reports"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpSchoolRestrictedCourses">
          <ListItemText
            primary="Restricted Courses"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpStatsAndTrends">
          <ListItemText
            primary="Stats & Trends"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
    </>
  );
};

export default CcpSchoolLinks;
